import { useFormik } from "formik";
import { useState } from "react";
import FilterBuilder from "../../../../../components/filter/FilterBuilder";
import { FilterRecord } from "../../../../../components/filter/filter-constant";
import useActiveComponentCountController from "../../../../../components/filter/use-ActiveComponentCountController";
import { useDebounce } from "../../../../../hooks/use-debounce";
import { SeverityRange } from "../../../../../queries/dashboard/use-dashboard-patient-questionaire";
import { useGetAllScreenerType } from "../../../../../queries/patient-chart/assessment/assement-forms/use-get-all-screener-type";
import { useProvidersList } from "../../../../../queries/provider/setting/use-providers-list";
import {
  DEF_PAGINATION,
  getXtenantId,
  replaceUnderScoreAddSpace,
} from "../../../../../utils/utils";
import { AssessmentFilterData } from "./AssessmentsList";

interface AssessmentFilterProps {
  activeAssessment: string;
  onApply: (v: AssessmentFilterData) => void;
  filters: AssessmentFilterData;
  setFilters: (v: AssessmentFilterData) => void;
  showSendSchedule?: boolean;
}

const AssessmentFilter = ({
  activeAssessment,
  onApply,
  filters,
  setFilters,
}: AssessmentFilterProps) => {
  useFormik<AssessmentFilterData>({
    initialValues: filters,
    enableReinitialize: true,
    onSubmit: (v) => {
      setFilters(v as any);
      onApply(v as any);
    },
  });

  const activeFilterCount = useActiveComponentCountController(filters);
  const [filterOpened, setFilterOpened] = useState(false);

  const [searchProviderGroupKey, setSearchProviderGroupKey] =
    useDebounce<string>("");
  const { data: providersList } = useProvidersList({
    pagination: DEF_PAGINATION,
    searchKey: searchProviderGroupKey,
    xTENANTID: getXtenantId(),
    enabled: filterOpened,
  });

  const [searchAssessmentTypeKey, setSearchAssessmentTypeKey] =
    useDebounce<string>("");
  const { data: screenerTypeList } = useGetAllScreenerType({
    pagination: DEF_PAGINATION,
    xTENANTID: getXtenantId(),
    searchString: searchAssessmentTypeKey,
    enabled: filterOpened,
  });

  const filterRecords: FilterRecord = {
    ...(activeAssessment === "submitted"
      ? {
          submitted_by: {
            type: "select",
            label: "Submitted By",
            placeholder: "Select Submitted By",
            options: [
              { label: "patient", value: "PATIENT" },
              { label: "provider", value: "PROVIDER" },
            ],
          },
          submitted_date: {
            type: "date",
            label: "Submitted Date",
            placeholder: "Select Submitted Date",
          },
          severity: {
            type: "select",
            label: "Severity Range",
            placeholder: "Select severity",
            options: [
              { label: "Low", value: "LOW" },
              { label: "Moderate", value: "MODERATE" },
              { label: "High", value: "HIGH" },
              { label: "Very Low", value: "VERY_LOW" },
              { label: "Very High", value: "VERY_HIGH" },
            ] as { value: SeverityRange; label: string }[],
          },
        }
      : {}),
    ...(activeAssessment === "sent_scheduled"
      ? {
          provider_Name: {
            type: "select",
            label: "Provider Name",
            options: providersList?.data?.content?.map((it) => ({
              value: it?.uuid,
              label: it?.firstName + " " + it?.lastName,
            })),
            placeholder: "Search Provider",
            onSearch: (val: string) => setSearchProviderGroupKey(val),
          },
          assessment_type: {
            type: "select",
            label: "Assessment Type",
            options: screenerTypeList?.data?.content?.map((it: any) => ({
              value: it,
              label: replaceUnderScoreAddSpace(it),
            })),
            placeholder: "Select Assessment Type",
            onSearch: (val: string) => setSearchAssessmentTypeKey(val),
          },
        }
      : {}),
  };

  return (
    <div onClick={() => !filterOpened && setFilterOpened(true)}>
      <FilterBuilder
        filters={filterRecords}
        onApply={onApply}
        prefillValues={filters as any}
        activeFilterCount={activeFilterCount}
        h="10rem"
      />
    </div>
  );
};

export default AssessmentFilter;
